import webpush from "./webpush";
import push from "./push";
import notification from "./notification";
import wallet from "./wallet";
import email from "./email";
import sms from "./sms";
import inapp from "./inapp";
import webhook from "./webhook";
import chatbot from "./chatbot";
import viber from "./viber";
import whatsapp from "./whatsapp";

import promotions from "./promotions";

export default {
  viber,
  whatsapp,
  email,
  sms,
  push,
  notification,
  wallet,
  webpush,
  inapp,
  webhook,
  chatbot,
  promotions,
};
